import { defineComponent as _defineComponent } from 'vue'

const __default__ = {}

import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'OzLoadingSpinner',
  props: {
    size: { default: 48 },
    color: { default: 'rainbow' },
    variation: { default: 'default' },
    darkMode: { type: [Boolean, String], default: 'auto' }
  },
  setup(__props: any) {

const props = __props as { size: number, color: 'rainbow' | 'black' | 'white' | 'yellow', variation: 'default' | 'dashed', darkMode: boolean | 'auto' };



const style = computed(() => {
  if (!props.size) return undefined
  return {
    width: `${props.size}px`,
    height: `${props.size}px`,
  }
})

const strokeWidth = computed(() => {
  if (!props.size) return 2
  if (props.size < 30) {
    return 4
  }
  return 2
})

return { __sfc: true,props, style, strokeWidth }
}

})